import { AlertCircle, Info, ChevronRight } from "lucide-react";

import { cn } from "@/lib/utils";

// FIN-3 — Banners contextuais.
// Banner 1: Cartão sem data (coral, click → modal Definir datas)
// Banner 2: Fatura estimada (amber, explicativo)
// Ambos só aparecem quando aplicáveis (sem nada a alertar = nada renderiza).

function _hasMissingDates(card) {
  return !card.closing_day || !card.due_day;
}

function Banner({ tone, icon: Icon, title, subtitle, action, onClick, testId }) {
  const TONE = {
    error: {
      border: "border-status-error/40",
      bg: "bg-status-error/5",
      iconBg: "bg-status-error/15",
      iconColor: "text-status-error",
      titleColor: "text-status-error",
    },
    warning: {
      border: "border-status-warning/40",
      bg: "bg-status-warning/5",
      iconBg: "bg-status-warning/15",
      iconColor: "text-status-warning",
      titleColor: "text-status-warning",
    },
  };
  const t = TONE[tone] || TONE.warning;
  const Wrapper = onClick ? "button" : "div";
  return (
    <Wrapper
      type={onClick ? "button" : undefined}
      onClick={onClick}
      className={cn(
        "w-full text-left rounded-xl border p-4 flex items-start gap-3 transition-all duration-fast",
        t.border, t.bg,
        onClick && "hover:bg-opacity-50 cursor-pointer",
      )}
      data-testid={testId}
    >
      <div className={cn("w-9 h-9 rounded-lg flex items-center justify-center shrink-0", t.iconBg)}>
        <Icon className={cn("w-4.5 h-4.5", t.iconColor)} aria-hidden="true" />
      </div>
      <div className="flex-1 min-w-0">
        <p className={cn("text-caption font-semibold mb-0.5", t.titleColor)}>
          {title}
        </p>
        {subtitle && (
          <p className="text-micro text-foreground-muted">{subtitle}</p>
        )}
      </div>
      {action && (
        <div className="flex items-center gap-1 text-caption font-medium text-foreground-muted shrink-0 self-center">
          {action}
          {onClick && <ChevronRight className="w-3.5 h-3.5" aria-hidden="true" />}
        </div>
      )}
    </Wrapper>
  );
}

export default function AlertBanners({
  creditCards,
  onConfigureDates,
  hasFaturaEstimada,
}) {
  const cardsWithoutDates = (creditCards || []).filter(_hasMissingDates);
  const showFaturaInfo = hasFaturaEstimada;

  if (cardsWithoutDates.length === 0 && !showFaturaInfo) return null;

  return (
    <div className="space-y-2.5" data-testid="contas-banners">
      {cardsWithoutDates.length > 0 && (
        <Banner
          tone="error"
          icon={AlertCircle}
          title={`● ${cardsWithoutDates.length} cartão${cardsWithoutDates.length === 1 ? "" : "ões"} sem data de fechamento configurada`}
          subtitle="Sem essas datas, o Nexo não calcula a fatura nem prevê o vencimento."
          action="Configurar"
          onClick={() => onConfigureDates?.(cardsWithoutDates[0])}
          testId="contas-banner-sem-data"
        />
      )}
      {showFaturaInfo && (
        <Banner
          tone="warning"
          icon={Info}
          title="Fatura estimada"
          subtitle="O valor exibido em cada cartão é estimado pelo Nexo com base no histórico. A fatura real só fica fechada após o dia de fechamento."
          testId="contas-banner-fatura-info"
        />
      )}
    </div>
  );
}
